export const isTouchDevice = "ontouchstart" in document.documentElement;

export const generateQueryString = (data = {}) => {
  let params = data;

  if (data instanceof FormData === true) {
    params = {};

    data.forEach((value, key) => (params[key] = value));
  }

  for (const key in params) {
    if (params[key] === "") {
      delete params[key];
    }
  }

  return new URLSearchParams(params);
};

export const trackGoogleAnalytics = (event) => {
  if (window.dataLayer) {
    window.dataLayer.push(event);
  }
};
